import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { selectUploadsForSet, selectVideoColorFinderJobByFlightId } from "./ColorFinderSlice"
import { useEffect, useState } from "react"
import { VideoMetadata } from "@nova/slice-video"
import { decode } from "@msgpack/msgpack"
import { outputFile } from "plugins/ColorFinder/VideoColorFinder/ColorFinderFiles"
import { getLocalVideoData } from "plugins/Video/FMV/module"
import { selectVideoColorFinderFlightById } from "features/entity-caching/flights/selectors"
import { fileManagementApi } from "features/data-management/files/fileManagementApi"
import { selectActivatedFireId } from "features/map/control/selectors"
import { selectActiveWorkspaceId } from "features/data-management/workspace/WorkspaceManagementSlice"

export const useVideoMetadata = (id: string) => {
    const dispatch = useAppDispatch()
    const fireId = useAppSelector(selectActivatedFireId)!
    const workspaceId = useAppSelector(selectActiveWorkspaceId())!
    const flight = useAppSelector(selectVideoColorFinderFlightById(id))
    const job = useAppSelector(selectVideoColorFinderJobByFlightId(id))
    const uploads = useAppSelector(selectUploadsForSet(id))
    const [videoMetadata, setVideoMetadata] = useState<VideoMetadata>()

    useEffect(() => {
        const getData = async () => {
            if (job && "mock" in job) {
                if (!uploads || uploads.length === 0) return
                const [url, metadata] = await getLocalVideoData(uploads)
                setVideoMetadata(metadata) // State var to be returned from this hook.

                return () => {
                    URL.revokeObjectURL(url)
                }
            } else if (job) {
                // v2
                const metadataPath = job.metadataPath
                const videoPath = job.videoPath
                const paths = [videoPath]
                if (job.resolutions) {
                    paths.push(
                        ...job.resolutions.map((e) => outputFile(workspaceId, fireId, id, e))
                    )
                }

                if (!metadataPath) return Promise.resolve(undefined)
                const s3Key = !!flight?.demoId ? `public/sample-data/${metadataPath}` : metadataPath
                const metadataBuffer = await (
                    await fileManagementApi.fetchFile(s3Key, { isDemo: !!flight?.demoId })
                ).arrayBuffer()
                const metadata = decode(metadataBuffer) as VideoMetadata

                setVideoMetadata(metadata) // State var to be returned from this hook.
            }
        }
        getData()
    }, [job, dispatch, fireId, id, workspaceId, uploads, flight?.demoId])

    return { videoMetadata }
}
